import RuleProvider from "diagram-js/lib/features/rules/RuleProvider";
import { is } from "bpmn-js/lib/util/ModelUtil";

const HIGH_PRIORITY = 5000;

export default class MyProviders extends RuleProvider {
  constructor(eventBus, palette, contextPad, elementRegistry) {
    super(eventBus);
    this.elementRegistry = elementRegistry;
    palette.registerProvider(this);
    contextPad.registerProvider(this);

    eventBus.on("element.dblclick", HIGH_PRIORITY, function (event) {
      event.stopPropagation();
    });

    eventBus.on("resize.start", HIGH_PRIORITY, function (event) {
      if (is(event.context.shape, "bpmn:Lane")) {
        return false;
      }
    });
  }

  init() {
    this.addRule("elements.move", HIGH_PRIORITY, (context) => {
      const { shapes, position } = context;

      for (const shape of shapes) {
        // Find and store the lane if not already stored
        if (!shape.lane) {
          shape.lane = this.elementRegistry.filter(
            (el) =>
              el.businessObject.$type === "bpmn:Lane" &&
              el.businessObject.flowNodeRef?.some(
                (node) => node.id === shape.businessObject.id
              )
          )[0];
        }

        if (
          shape.lane &&
          position &&
          !this.isWithinBounds(position, shape.lane)
        ) {
          return false; // Disallow the move if outside lane bounds
        }
      }

      // Not returning anything means other rule providers can still do their work
      // this allows us to reuse the existing BPMN rules
    });

    this.addRule("elements.delete", HIGH_PRIORITY, function (context) {
      return false; // Returning false prevents deletion
    });
  }

  isWithinBounds(position, lane) {
    const { x, y, width, height } = lane;
    return (
      position.x >= x &&
      position.y >= y &&
      position.x <= x + width &&
      position.y <= y + height
    );
  }

  /*Reference: https://github.com/bpmn-io/bpmn-js/blob/develop/lib/features/palette/PaletteProvider.js*/

  getPaletteEntries() {
    return (entries) => {
      // Return only 'hand-tool' and 'space-tool'
      return {
        "hand-tool": entries["hand-tool"],
        "space-tool": entries["space-tool"],
      };
    };
  }

  getContextPadEntries() {
    return () => null; // Remove all context pad entries
  }
}

MyProviders.$inject = ["eventBus", "palette", "contextPad", "elementRegistry"];
